import React, { FC } from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { useTranslation } from '@wix/yoshi-flow-editor';

import { useMember } from '../../../../../../contexts/widget';
import { classes } from './LoginEmail.st.css';

export const LoginEmail: FC = () => {
  const { t } = useTranslation();
  const { loginEmail } = useMember();

  return (
    <div className={classes.root}>
      <Text className={classes.title} tagName="div">
        {t('app.widget.login-email.title')}:
      </Text>

      <Text className={classes.title} tagName="div">
        {loginEmail}
      </Text>

      <Text className={classes.subtitle} tagName="div">
        {t('app.widget.login-email.subtitle')}
      </Text>
    </div>
  );
};
